module.exports = __webpack_public_path__ + "media/images/common/defaults/cover-8cf6fc8073659e940782e8f48f55869c.png";